import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'
import { createStructuredSelector } from 'reselect'

import {
  itemsSelector,
  cartStatusSelector,
  waitingForGiftCardArrivalSelector,
} from '@/checkout-instore-legacy/cart/selectors'

import DefaultSummary from '../components/DefaultSummary'
import { orderSelector } from '@/checkout-instore-legacy/order/selectors'
import useNetwork from '@/checkout-instore-legacy/hooks/useNetwork'

const mapStateToPropsSelector = createStructuredSelector({
  order: orderSelector,
  items: itemsSelector,
  cartStatus: cartStatusSelector,
  waitingForGiftCardArrival: waitingForGiftCardArrivalSelector,
})

const DefaultSummaryContainer = (props: any) => {
  const summaryProps = {
    ...props,
    isOnline: useNetwork(),
  }

  return <DefaultSummary {...summaryProps} />
}

export default withRouter(
  connect(mapStateToPropsSelector, undefined)(DefaultSummaryContainer)
)
